export let wordlist = {
    // General
    "loading": {
        "en": "loading",
        "fr": "chargement",
        "de": "laden",
        "es": "cargando",
        "it": "caricamento",
        "nl": "laden",
        "pt": "carregando"
    },

    "save": {
        "en": "save",
        "fr": "enregistrer",
        "de": "speichern",
        "es": "guardar",
        "it": "salvare",
        "pt": "guardar",
        "nl": "opslaan"
    },

    "back" : {
        "en": "back",
        "fr": "retour",
        "de": "zurück",
        "es": "atrás",
        "it": "indietro",
        "nl": "terug",
        "pt": "voltar"
    },
    
    "next": {
        "en": "next",
        "fr": "suivant",
        "de": "weiter",
        "es": "siguiente",
        "it": "avanti",
        "nl": "volgende",
        "pt": "seguinte"
    },

    "previous": {
        "en": "previous",
        "fr": "précédent",
        "de": "zurück",
        "es": "anterior",
        "it": "indietro",
        "nl": "vorige",
        "pt": "anterior"
    },

    // Login page

    "email": {
        "en": "email",
        "fr": "e-mail",
        "de": "e-mail",
        "es": "correo electrónico",
        "it": "email",
        "nl": "e-mail",
        "pt": "email"
    },
    "password": {
        "en": "password",
        "fr": "mot de passe",
        "de": "passwort",
        "es": "contraseña",
        "it": "password",
        "nl": "wachtwoord",
        "pt": "palavra-passe"
    },
    "login": {
        "en": "login",
        "fr": "se connecter",
        "de": "anmeldung",
        "es": "iniciar sesión",
        "it": "accedi",
        "nl": "inloggen",
        "pt": "iniciar sessão"
    },
    "forgot password?": {
        "en": "forgot password?",
        "fr": "mot de passe oublié ?",
        "de": "passwort vergessen?",
        "es": "¿olvidaste tu contraseña?",
        "it": "hai dimenticato la password?",
        "nl": "wachtwoord vergeten?",
        "pt": "esqueceu-se da palavra-passe?"
    },
    "don't have an account yet?": {
        "en": "don't have an  account yet?",
        "fr": "vous n'avez pas encore de compte?",
        "de": "Haben Sie noch kein Konto?",
        "es": "¿aún no tienes una cuenta?",
        "it": "non hai ancora un account?",
        "nl": "heb je nog geen account?",
        "pt": "ainda não tem uma conta?"
    },
    "register": {
        "en": "register",
        "fr": "s'inscrire",
        "de": "registrieren",
        "es": "regístrate",
        "it": "registrati",
        "nl": "registreren",
        "pt": "registar"
    },
    "make your winery known to all wine lovers": {
        "en": "make your winery known to all wine lovers",
        "fr": "faites connaître votre domaine à tous les amateurs de vin",
        "de": "machen Sie Ihr Weingut bei allen Weinliebhabern bekannt",
        "es": "dé a conocer su bodega a todos los amantes del vino",
        "it": "fai conoscere la tua cantina a tutti gli amanti del vino",
        "pt": "dê a conhecer a sua adega a todos os amantes de vinho",
        "nl": "maak uw wijnhuis bekend bij alle wijnliefhebbers"
    }, 

    "funware for wine lovers developed and ©copyrighted by N'JOY Information Technology": {
        "en": "funware for wine lovers by N'JOY Information Technology ©",
        "fr": "funware pour les amateurs de vin par N'JOY Information Technology ©",
        "de": "funware für weinliebhaber von N'JOY Information Technology ©",
        "es": "funware para amantes del vino por N'JOY Information Technology ©",
        "it": "funware per gli amanti del vino di N'JOY Information Technology ©",
        "nl": "funware voor wijnliefhebbers door N'JOY Information Technology ©",
        "pt": "funware para amantes do vinho por N'JOY Information Technology ©"
    },

    // Menu

    "information": {
        "en": "information",
        "fr": "information",
        "de": "Information",
        "es": "información",
        "it": "informazione",
        "nl": "informatie",
        "pt": "informação"
        },

    "general": {
        "en": "general",
        "fr": "général",
        "de": "allgemein",
        "es": "general",
        "it": "generale",
        "nl": "algemeen",
        "pt": "geral"
    },

    "contact": {
        "en": "contact",
        "fr": "contact",
        "de": "Kontakt",
        "es": "contacto",
        "it": "contatto",
        "nl": "contact",
        "pt": "contacto"
    },

    "social media": {
        "en": "social media",
        "fr": "réseaux sociaux",
        "de": "soziale Medien",
        "es": "redes sociales",
        "it": "social media",
        "nl": "sociale media",
        "pt": "redes sociais"
    },

    "gallery": {
        "en": "gallery",
        "fr": "galerie",
        "de": "Galerie",
        "es": "galería",
        "it": "galleria",
        "nl": "galerij",
        "pt": "galeria"
    },

    "wines": {
        "en": "wines",
        "fr": "vins",
        "de": "Weine",
        "es": "vinos",
        "it": "vini",
        "nl": "wijnen",
        "pt": "vinhos"
    },

    "preview": {
        "en": "preview",
        "fr": "aperçu",
        "de": "Vorschau",
        "es": "vista previa",
        "it": "anteprima",
        "nl": "voorbeeld",
        "pt": "pré-visualização"
    },

    "about us": {
        "en": "about us",
        "fr": "à propos de nous",
        "de": "über uns",
        "es": "sobre nosotros",
        "it": "chi siamo",
        "nl": "over ons",
        "pt": "sobre nós"
    },

    "log off": {
        "en": "log off",
        "fr": "se déconnecter",
        "de": "abmelden",
        "es": "cerrar sesión",
        "it": "disconnettersi",
        "nl": "afmelden",
        "pt": "terminar sessão"
    },

    // General
    
    "general information": {
        "en": "general information",
        "fr": "informations générales",
        "de": "allgemeine Informationen",
        "es": "información general",
        "it": "informazioni generali",
        "nl": "algemene informatie",
        "pt": "informações gerais"
    },

    "winery name": {
        "en": "winery name",
        "fr": "nom du domaine",
        "de": "Name des Weinguts",
        "es": "nombre de la bodega",
        "it": "nome della cantina",
        "nl": "naam van het wijnhuis",
        "pt": "nome da adega"
    },

    "winery description": {
        "en": "winery description",
        "fr": "description du domaine",
        "de": "Beschreibung des Weinguts",
        "es": "descripción de la bodega",
        "it": "descrizione della cantina",
        "nl": "beschrijving van het wijnhuis",
        "pt": "descrição da adega"
    },

    // Contact

    "contact": {
        "en": "contact",
        "fr": "contact",
        "de": "kontakt",
        "es": "contacto",
        "it": "contatto",
        "nl": "contact",
        "pt": "contacto"
    },

    "address line 1": {
        "en": "address line 1",
        "fr": "adresse ligne 1",
        "de": "adresszeile 1",
        "es": "dirección línea 1",
        "it": "indirizzo riga 1",
        "nl": "adresregel 1",
        "pt": "linha de endereço 1"
    },

    "address line 2": {
        "en": "address line 2",
        "fr": "adresse ligne 2",
        "de": "adresszeile 2",
        "es": "dirección línea 2",
        "it": "indirizzo riga 2",
        "nl": "adresregel 2",
        "pt": "linha de endereço 2"
    },

    "zip": {
        "en": "zip",
        "fr": "code postal",
        "de": "postleitzahl",
        "es": "código postal",
        "it": "CAP",
        "nl": "postcode",
        "pt": "código postal"
    },

    "city": {
        "en": "city",
        "fr": "ville",
        "de": "stadt",
        "es": "ciudad",
        "it": "città",
        "nl": "stad",
        "pt": "cidade"
    },

    "country": {
        "en": "country",
        "fr": "pays",
        "de": "land",
        "es": "país",
        "it": "paese",
        "nl": "land",
        "pt": "país"
    },

    "phone": {
        "en": "phone",
        "fr": "téléphone",
        "de": "telefon",
        "es": "teléfono",
        "it": "telefono",
        "nl": "telefoon",
        "pt": "telefone"
    },

    "email": {
        "en": "email",
        "fr": "email",
        "de": "e-mail",
        "es": "correo electrónico",
        "it": "email",
        "nl": "e-mail",
        "pt": "email"
    },

    // Social Media

    "web and social media": {
        "en": "web and social media",
        "fr": "web et réseaux sociaux",
        "de": "web und soziale medien",
        "es": "web y redes sociales",
        "it": "web e social media",
        "nl": "web en sociale media",
        "pt": "web e redes sociais"
    },

    "webpage": {
        "en": "webpage",
        "fr": "site web",
        "de": "webseite",
        "es": "página web",
        "it": "sito web",
        "nl": "website",
        "pt": "página web"
    },

    // Winery Pictures

    "winery pictures": {
        "en": "winery pictures",
        "fr": "photos du domaine",
        "de": "bilder des weinguts",
        "es": "fotos de la bodega",
        "it": "foto della cantina",
        "nl": "foto’s van het wijndomein",
        "pt": "fotos da vinícola"
    }, 
    
    // Wine Edit

    "add wine": {
        "en": "add wine",
        "fr": "ajouter un vin",
        "de": "wein hinzufügen",
        "es": "añadir vino",
        "it": "aggiungi vino",
        "nl": "wijn toevoegen",
        "pt": "adicionar vinho"
    },

    "add wines": {
        "en": "add wines",
        "fr": "ajouter vins",
        "de": "Weine hinzufügen",
        "es": "añadir vinos",
        "it": "aggiungi vini",
        "nl": "wijnen toevoegen",
        "pt": "adicionar vinhos"
    },

    "page": {
        "en": "page",
        "fr": "page",
        "de": "seite",
        "es": "página",
        "it": "pagina",
        "pt": "página",
        "nl": "pagina"
    },

    "winery name": {
        "en": "winery name",
        "fr": "nom du domaine",
        "de": "Name des Weinguts",
        "es": "nombre de la bodega",
        "it": "nome della cantina",
        "nl": "naam van het wijnhuis",
        "pt": "nome da vinícola"
    },

    "wine name": {
        "en": "wine name",
        "fr": "nom du vin",
        "de": "Name des Weins",
        "es": "nombre del vino",
        "it": "nome del vino",
        "nl": "naam van de wijn",
        "pt": "nome do vinho"
    },

     "country": {
        "en": "country",
        "fr": "pays",
        "de": "Land",
        "es": "país",
        "it": "paese",
        "nl": "land",
        "pt": "país"
    },

    "region": {
        "en": "region",
        "fr": "région",
        "de": "Region",
        "es": "región",
        "it": "regione",
        "nl": "regio",
        "pt": "região"
    },

    "appellation": {
        "en": "appellation",
        "fr": "appellation",
        "de": "Appellation",
        "es": "denominación",
        "it": "denominazione",
        "nl": "appellatie",
        "pt": "denominação"
    },

    "classification": {
        "en": "classification",
        "fr": "classification",
        "de": "Klassifikation",
        "es": "clasificación",
        "it": "classificazione",
        "nl": "classificatie",
        "pt": "classificação"
    },

    "color": {
        "en": "color",
        "fr": "couleur",
        "de": "Farbe",
        "es": "color",
        "it": "colore",
        "nl": "kleur",
        "pt": "cor"
    },

    "sparkling": {
        "en": "sparkling",
        "fr": "effervescent",
        "de": "Sekt",
        "es": "espumoso",
        "it": "spumante",
        "nl": "mousserend",
        "pt": "espumante"
    },

    "sweet": {
        "en": "sweet",
        "fr": "doux",
        "de": "süß",
        "es": "dulce",
        "it": "dolce",
        "nl": "zoet",
        "pt": "doce"
    },

    "detail": {
        "en": "detail",
        "fr": "détail",
        "de": "details",
        "es": "detalle",
        "it": "dettaglio",
        "nl": "detail",
        "pt": "detalhe"
    },
    "pictures": {
        "en": "pictures",
        "fr": "photos",
        "de": "bilder",
        "es": "fotos",
        "it": "foto",
        "nl": "afbeeldingen",
        "pt": "fotos"
    },
    "impressions": {
        "en": "impressions",
        "fr": "impressions",
        "de": "eindrücke",
        "es": "impresiones",
        "it": "impressioni",
        "nl": "indrukken",
        "pt": "impressões"
    },

    "grapes": {
        "en": "grapes",
        "fr": "cépages",
        "de": "Rebsorten",
        "es": "variedades",
        "it": "vitigni",
        "pt": "castas",
        "nl": "druivensoorten"
    },
    "longevity": {
        "en": "longevity",
        "fr": "potentiel de garde",
        "de": "Lagerfähigkeit",
        "es": "longevidad",
        "it": "longevità",
        "pt": "longevidade",
        "nl": "bewaarpotentieel"
    },
    "vines": {
        "en": "vines",
        "fr": "vignes",
        "de": "Reben",
        "es": "viñas",
        "it": "viti",
        "pt": "videiras",
        "nl": "wijnstokken"
    },
    "yields": {
        "en": "yields",
        "fr": "rendements",
        "de": "Erträge",
        "es": "rendimientos",
        "it": "rese",
        "pt": "rendimentos",
        "nl": "opbrengsten"
    },
    "vinification": {
        "en": "vinification",
        "fr": "vinification",
        "de": "Vinifikation",
        "es": "vinificación",
        "it": "vinificazione",
        "pt": "vinificação",
        "nl": "vinificatie"
    },
    "aging": {
        "en": "aging",
        "fr": "élevage",
        "de": "Ausbau",
        "es": "crianza",
        "it": "affinamento",
        "pt": "envelhecimento",
        "nl": "rijping"
    },
    "alcohol": {
        "en": "alcohol",
        "fr": "alcool",
        "de": "Alkohol",
        "es": "alcohol",
        "it": "alcol",
        "pt": "álcool",
        "nl": "alcohol"
    },

    "tasting notes": {
        "en": "tasting notes",
        "fr": "notes de dégustation",
        "de": "verkostungsnotizen",
        "es": "notas de cata",
        "it": "note di degustazione",
        "nl": "proefnotities",
        "pt": "notas de prova"
    },

    // Preview Page

    "our wines": {
        "en": "our wines",
        "fr": "nos vins",
        "de": "unsere Weine",
        "es": "nuestros vinos",
        "it": "i nostri vini",
        "nl": "onze wijnen",
        "pt": "nossos vinhos"
    },
    "This page is now available on": {
        "en": "This page is now available on",
        "fr": "Cette page est désormais disponible sur",
        "de": "Diese Seite ist jetzt verfügbar auf",
        "es": "Esta página ahora está disponible en",
        "it": "Questa pagina è ora disponibile su",
        "nl": "Deze pagina is nu beschikbaar op",
        "pt": "Esta página agora está disponível em"
    },

    "translating": {
        "en": "translating",
        "fr": "traduction",
        "de": "übersetzen",
        "es": "traducción",
        "it": "traduzione",
        "nl": "vertalen",
        "pt": "tradução"
    },

     // Register and Profile pages

    "personal information": {
        "en": "personal information",
        "fr": "informations personnelles",
        "de": "persönliche Informationen",
        "es": "información personal",
        "it": "informazioni personali",
        "pt": "informações pessoais",
        "nl": "persoonlijke informatie"
    },

    "first name": {
        "en": "first name",
        "fr": "prénom",
        "de": "Vorname",
        "es": "nombre",
        "it": "nome",
        "pt": "primeiro nome",
        "nl": "voornaam"
    },

    "last name": {
        "en": "last name",
        "fr": "nom de famille",
        "de": "Nachname",
        "es": "apellido",
        "it": "cognome",
        "pt": "apelido",
        "nl": "achternaam"
    },

    "gender": {
        "en": "gender",
        "fr": "genre",
        "de": "Geschlecht",
        "es": "género",
        "it": "genere",
        "pt": "gênero",
        "nl": "geslacht"
    },

    "male": {
        "en": "male",
        "fr": "homme",
        "de": "männlich",
        "es": "masculino",
        "it": "maschile",
        "nl": "man",
        "pt": "masculino"
    },
    "female": {
        "en": "female",
        "fr": "femme",
        "de": "weiblich",
        "es": "femenino",
        "it": "femminile",
        "nl": "vrouw",
        "pt": "feminino"
    },
    "non-binary": {
        "en": "non-binary",
        "fr": "non binaire",
        "de": "nicht-binär",
        "es": "no binario",
        "it": "non binario",
        "nl": "non-binair",
        "pt": "não binário"
    },

    "language": {
        "en": "language",
        "fr": "langue",
        "de": "Sprache",
        "es": "idioma",
        "it": "lingua",
        "pt": "idioma",
        "nl": "taal"
    },

    "date of birth": {
        "en": "date of birth",
        "fr": "date de naissance",
        "de": "Geburtsdatum",
        "es": "fecha de nacimiento",
        "it": "data di nascita",
        "pt": "data de nascimento",
        "nl": "geboortedatum"
    },

    "wyne information": {
        "en": "wyne information",
        "fr": "informations wynelover",
        "de": "wynelover-Informationen",
        "es": "información wynelover",
        "it": "informazioni wynelover",
        "pt": "informações do wynelover",
        "nl": "wynelover informatie"
    },

    "cellar name": {
        "en": "cellar name",
        "fr": "nom de la cave à vin",
        "de": "Name des Weinkellers",
        "es": "nombre de la cava",
        "it": "nome della cantina",
        "pt": "nome da adega",
        "nl": "naam van de kelder"
    },

    "account information": {
        "en": "account information",
        "fr": "informations du compte",
        "de": "Kontoinformationen",
        "es": "información de la cuenta",
        "it": "informazioni sull'account",
        "pt": "informações da conta",
        "nl": "account informatie"
    },

    "confirm password": {
        "en": "confirm password",
        "fr": "confirmer le mot de passe",
        "de": "Passwort bestätigen",
        "es": "confirmar contraseña",
        "it": "conferma la password",
        "pt": "confirmar senha",
        "nl": "bevestig wachtwoord"
    },

    "I agree to": {
        "en": "I agree to",
        "fr": "J'accepte",
        "de": "Ich stimme den",
        "es": "Acepto",
        "it": "Accetto",
        "pt": "Eu concordo com",
        "nl": "Ik ga akkoord met"
    },

    "WyneLover Terms of Use and Privacy Policy": {
        "en": "WyneLover Terms of Use and Privacy Policy",
        "fr": "les conditions d'utilisation et Politique de confidentialité de WyneLover",
        "de": "WyneLover Nutzungsbedingungen und Datenschutzrichtlinie",
        "es": "los términos de uso y Política de privacidad de WyneLover",
        "it": "i termini di utilizzo e Politica sulla privacy di WyneLover",
        "pt": "os Termos de Uso e a Política de Privacidade da WyneLover",
        "nl": "de Gebruiksvoorwaarden en het Privacybeleid van WyneLover"
    },

    "I want to change my password": {
        "en": "I want to change my password",
        "fr": "Je veux changer mon mot de passe",
        "de": "Ich möchte mein Passwort ändern",
        "es": "Quiero cambiar mi contraseña",
        "it": "Voglio cambiare la mia password",
        "pt": "Quero mudar minha senha",
        "nl": "Ik wil mijn wachtwoord wijzigen"
    },

    "old password": {
        "en": "old password",
        "fr": "ancien mot de passe",
        "de": "altes Passwort",
        "es": "contraseña antigua",
        "it": "vecchia password",
        "pt": "senha antiga",
        "nl": "oud wachtwoord"
    },

    "new password": {
        "en": "new password",
        "fr": "nouveau mot de passe",
        "de": "neues Passwort",
        "es": "nueva contraseña",
        "it": "nuova password",
        "pt": "nova senha",
        "nl": "nieuw wachtwoord"
    },

    "confirm new password": {
        "en": "confirm new password",
        "fr": "confirmer le nouveau mot de passe",
        "de": "neues Passwort bestätigen",
        "es": "confirmar nueva contraseña",
        "it": "conferma la nuova password",
        "pt": "confirmar nova senha",
        "nl": "bevestig nieuw wachtwoord"
    },

    "update": {
        "en": "update",
        "fr": "mettre à jour",
        "de": "aktualisieren",
        "es": "actualizar",
        "it": "aggiornare",
        "pt": "atualizar",
        "nl": "bijwerken"
    },

    // Home Page

    "Your chosen language is": {
        "en": "Your chosen language is",
        "fr": "Votre langue choisie est le",
        "de": "Ihre gewählte Sprache ist",
        "es": "Su idioma elegido es",
        "it": "La tua lingua scelta è il",
        "nl": "Uw gekozen taal is",
        "pt": "O idioma escolhido é"
    },

    "while your profile language is": {
        "en": "while your profile language is",
        "fr": "tandis que la langue de votre profil est",
        "de": "während Ihre Profilsprache ist",
        "es": "mientras que el idioma de su perfil es",
        "it": "mentre la lingua del tuo profilo è il",
        "nl": "terwijl uw profieltaal is",
        "pt": "enquanto o idioma do seu perfil é"
    },

    "Option 1: Shall I switch over to your profile language and continue in": {
        "en": "Option 1: Shall I switch over to your profile language and continue in",
        "fr": "Option 1: Dois-je passer à la langue de votre profil et continuer en",
        "de": "Option 1: Soll ich zur Sprache Ihres Profils wechseln und in",
        "es": "Opción 1: ¿Debo cambiar al idioma de su perfil y continuar en",
        "it": "Opzione 1: Devo passare alla lingua del tuo profilo e continuare in",
        "nl": "Optie 1: Zal ik overschakelen naar uw profieltaal en doorgaan in",
        "pt": "Opção 1: Devo mudar para o idioma do seu perfil e continuar em"
    },

    "Option 2: Shall I change your profile language to": {
        "en": "Option 2: Shall I change your profile language to",
        "fr": "Option 2: Dois-je changer la langue de votre profil en",
        "de": "Option 2: Soll ich Ihre Profilsprache ändern auf",
        "es": "Opción 2: ¿Debo cambiar el idioma de su perfil a",
        "it": "Opzione 2: Devo cambiare la lingua del tuo profilo",
        "nl": "Optie 2: Zal ik uw profieltaal wijzigen naar",
        "pt": "Opção 2: Devo mudar o idioma do seu perfil para"
    },

    "and continue in": {
        "en": "and continue in",
        "fr": "et continuer en",
        "de": "und fortfahren auf",
        "es": "y continuar en",
        "it": "e continuare in",
        "nl": "en doorgaan in",
        "pt": "e continuar em"
    },    

}

export function translate_word(string, language) {
    let local_debug = false
    if (local_debug) console.log("original:", string)
    if (wordlist[string] && wordlist[string][language]) {
        if (local_debug) console.log("translation:", wordlist[string][language])
        return wordlist[string][language];
    } else {
        if (local_debug) console.log("translation:", string)
        return string;
    }
}